import { connect } from 'react-redux'
import { selectCurrentAgent } from 'selectors/agents/base'
import {
  selectIntegrationCredentialsAreLoaded,
  selectIntegrationCredentialsForProvider,
} from 'ducks/integrations'
import View from './view'

const select = state => ({
  currentAgent: selectCurrentAgent(state),
  credentialsLoaded: selectIntegrationCredentialsAreLoaded(state),
  credentials: selectIntegrationCredentialsForProvider(state, {
    provider: 'SHOPIFY_V2',
  }),
})

export default connect(select, null)(View)
